export const FILE_TYPE_MAP: Record<string, { label: string; style: string }> = {
  pdf: { label: "PDF", style: "pdf" },
  xlsx: { label: "XLS", style: "xls" },
  xls: { label: "XLS", style: "xls" },
  csv: { label: "CSV", style: "xls" },
  pptx: { label: "PPT", style: "ppt" },
  ppt: { label: "PPT", style: "ppt" },
  doc: { label: "DOC", style: "default" },
  docx: { label: "DOC", style: "default" },
  txt: { label: "TXT", style: "default" },
  json: { label: "JSON", style: "default" },
  epub: { label: "EPUB", style: "default" },
  png: { label: "PNG", style: "default" },
  jpg: { label: "JPG", style: "default" },
  jpeg: { label: "JPG", style: "default" },
  rtf: { label: "RTF", style: "default" },
  odt: { label: "ODT", style: "default" },
  gif: { label: "GIF", style: "default" },
  webp: { label: "WEBP", style: "default" },
  md: { label: "MD", style: "default" },
};

export const ANALYTICS_VALID_FILE_EXTENSIONS = [".csv", ".xlsx"];

export const getFileExtension = (filename: string): string =>
  filename.split(".").pop()?.toLowerCase() ?? "";

export const getFileTypeInfo = (filename: string) => {
  const ext = getFileExtension(filename);
  return FILE_TYPE_MAP[ext] ?? { label: ext.toUpperCase(), style: "default" };
};

const BYTES_PER_KILOBYTE = 1024;
const BYTES_PER_MEGABYTE = 1024 * 1024;

export const formatFileSize = (bytes: number): string => {
  if (bytes < BYTES_PER_KILOBYTE) return `${bytes} B`;
  if (bytes < BYTES_PER_MEGABYTE)
    return `${(bytes / BYTES_PER_KILOBYTE).toFixed(1)} KB`;
  return `${(bytes / BYTES_PER_MEGABYTE).toFixed(1)} MB`;
};

export const getDisplayFilename = (filename: string): string => {
  const lastDotIndex = filename.lastIndexOf(".");
  if (lastDotIndex === -1) return filename;
  return filename.substring(0, lastDotIndex);
};
